@if (!userLoggedIn || (userLoggedIn && (!webEnabled))) {
  <div>
    @if (topheadline | async ; as item) {
      <div class="LO_allProduct col-xs-12 prodLanding_prodSectionUK" id="prodLanding_prodSection"
        >
        <div class="col-xs-12 col-md-6 prodLanding_prodCol">
          <div class="col-xs-12 prod_content">
            <div class="col-xs-12 prodLanding_prodimg" id="prodLanding_prodimg1">
              <img [src]="getImage(item.media)" alt="aQIV Product Logo">
              <div class="col-xs-12 prodLanding_prodheader no-pad">{{item.h2content}}</div>
              <div class="col-xs-12 prodLanding_prodcontent no-pad" [innerHTML]="item.content"></div>
            </div>
          </div>
          <div class="col-xs-12" id="prodLanding_learnmorebtn"><a (click)="saveUrlAndRedirect(item.largeparagraphcontent, item.materialSubHeading)">{{item.paragraphcontent}}</a></div>
        </div>
      </div>
    }
  </div>
}
<!-- 
@if (userLoggedIn && webEnabled) {
  <div class="LI_allProduct">
    @if (topheadline | async ; as item) {
      <div class="product-3col">
        
        <div class="product-3col__body product-3col__bodyUK marginUK" id="product_row1">
          <div class="product-3col__item col-md-6 product-3col__itemUK">
            <img alt="Flucelvax Quadrivalent logo" [src]="getImage(item.media)" alt="aQIV Product Logo">
            <h3>{{item.headline}}</h3>
            <p [innerHTML]="item.content"></p>
            <div class="btnParent">
              <a class="no-underline" [routerLink]="item.urlLink" [innerHTML]="item.h3content"></a>
            </div>
          </div>
      </div>
      <div class="speedbump__content"></div>
    </div>
  }
</div>
} -->

@if (userLoggedIn && webEnabled) {
 @if (topheadline | async ; as item) { 
  <div class="Login_allProduct" id="Login_allProduct">
    <div class="allprodCardContaner">
        <div class="allprodCard">
          <div class="allprod_wrapper">
          <div class="allprodImgWrap">
            <img alt="tiv product logo" [src]="getImage(item.media)" alt="aQIV Product Logo">
          </div>
          <div class="allprodcardheader" [innerHTML]="item.headline"></div>
          <div class="allprodcontent" [innerHTML]="item.content"></div>
        </div>
          <div class="allprod_findbtn">
            <button class="allprodbtn" [routerLink]="item.urlLink" [innerHTML]="item.paragraphcontent">
              <span  class="findbtn" [innerHTML]="item.paragraphcontent"></span>
            </button>
          </div>
        </div>
    </div>
  </div>
}
}
